// extracted by mini-css-extract-plugin
export var pAttention = "attention-module--p-attention--2kjdO";
export var oButton = "attention-module--o-button--1OHW7";